import { acReferenceDataTypes } from '../acReduxExports';

const referenceDataInitialState: AcReferenceDataState = {
	type: '',
	chargerHistoryTypeReferenceData: null,
	alarmSeverityReferenceData: null,
	alarmTypeReferenceData: null,
	chargerVisibleIdReferenceData: null,
	acCustomerReferenceData: null,
	chargingStationReferenceData: null,
	acChargerLocationReferenceData: null,
	parametersReferenceData: null,
	chargerProductTypeReferenceData: null,
	versionReleasesSoftwareVersionReferenceData: null,
	softwareVersionReferenceData: null,
	versionProductTypeReferenceData: null,
	ruleAlarmTypeReferenceData: null,
	acAlarmRuleReferenceData: null,
	versionUpgradeSoftwareVersionReferenceData: null,
};

const acReferenceDataReducer = (
	state: AcReferenceDataState = referenceDataInitialState,
	action: AcReferenceDataAction,
): AcReferenceDataState => {
	switch (action.type) {
		case acReferenceDataTypes.FETCH_AC_HISTORY_TYPE_REFERENCE_DATA:
			return {
				...state,
				chargerHistoryTypeReferenceData: action.chargerHistoryTypeReferenceData,
			};
		case acReferenceDataTypes.FETCH_AC_ALARM_SEVERITY_REFERENCE_DATA:
			return {
				...state,
				alarmSeverityReferenceData: action.alarmSeverityReferenceData,
			};
		case acReferenceDataTypes.FETCH_AC_ALARM_TYPE_REFERENCE_DATA:
			return {
				...state,
				alarmTypeReferenceData: action.alarmTypeReferenceData,
			};
		case acReferenceDataTypes.FETCH_AC_CHARGER_VISIBLE_ID_REFERENCE_DATA:
			return {
				...state,
				chargerVisibleIdReferenceData: action.chargerVisibleIdReferenceData,
			};
		case acReferenceDataTypes.FETCH_AC_CUSTOMER_REFERENCE_DATA:
			return {
				...state,
				acCustomerReferenceData: action.acCustomerReferenceData,
			};
		case acReferenceDataTypes.FETCH_AC_CHARGER_STATION_REFERENCE_DATA:
			return {
				...state,
				chargingStationReferenceData: action.chargingStationReferenceData,
			};

		case acReferenceDataTypes.FETCH_AC_PARAMETERS_REFERENCE_DATA:
			return {
				...state,
				parametersReferenceData: action.parametersReferenceData,
			};

		case acReferenceDataTypes.FETCH_AC_CHARGER_PRODUCT_TYPE_REFERENCE_DATA:
			return {
				...state,
				chargerProductTypeReferenceData: action.chargerProductTypeReferenceData,
			};

		case acReferenceDataTypes.FETCH_AC_CHARGER_LOCATION_REFERENCE_DATA:
			return {
				...state,
				acChargerLocationReferenceData: action.acChargerLocationReferenceData,
			};
		case acReferenceDataTypes.FETCH_AC_VERSION_RELEASES_SOFTWARE_VERSION_REFERENCE_DATA:
			return {
				...state,
				versionReleasesSoftwareVersionReferenceData:
					action.versionReleasesSoftwareVersionReferenceData,
			};
		case acReferenceDataTypes.FETCH_AC_SOFTWARE_VERSION_REFERENCE_DATA:
			return {
				...state,
				softwareVersionReferenceData: action.softwareVersionReferenceData,
			};
		case acReferenceDataTypes.FETCH_AC_VERSION_PRODUCT_TYPE_REFERENCE_DATA:
			return {
				...state,
				versionProductTypeReferenceData: action.versionProductTypeReferenceData,
			};

		case acReferenceDataTypes.FETCH_AC_RULE_ALARM_TYPE_REFERENCE_DATA:
			return {
				...state,
				ruleAlarmTypeReferenceData: action.ruleAlarmTypeReferenceData,
			};
		case acReferenceDataTypes.FETCH_AC_ALARM_RULE_REFERENCE_DATA:
			return {
				...state,
				acAlarmRuleReferenceData: action.acAlarmRuleReferenceData,
			};
		case acReferenceDataTypes.FETCH_AC_VERSION_UPGRADE_SOFTWARE_VERSION_REFERENCE_DATA:
			return {
				...state,
				versionUpgradeSoftwareVersionReferenceData:
					action.versionUpgradeSoftwareVersionReferenceData,
			};
		default:
			return state;
	}
};

export default acReferenceDataReducer;
